import "./src/css/index.css"
import React from "react"
import { CalculatorProvider } from "./src/context/CalculatorContext"

export const wrapRootElement = ({ element }) => (
  <CalculatorProvider>{element}</CalculatorProvider>
)